export const convertDurationToString = (time: number) => {
  if (!time || Number.isNaN(time)) return ''

  const minutes = Math.floor(time / 60)
  const seconds = Math.floor(time - minutes * 60)
  const secondsStr = seconds < 10 ? `0${seconds}` : seconds
  const duration = `${minutes}:${secondsStr}`

  return duration
}
